<script lang="ts" setup>
import CountryFlag from 'vue-country-flag-next'

defineProps<{
  language: string
  languageTag?: string
  stacked?: boolean
}>()
</script>

<template>
  <div
    :class="
      stacked ? 'flex flex-col items-center gap-1 text-center' : 'flex items-center gap-x-spacing-sm'
    ">
    <CountryFlag :country="languageTag?.split('-').pop()" size="small" />
    <span class="secu-body leading-tight">{{ language }}</span>
  </div>
</template>
